var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocusUnderline6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 3,
    viewBox: "0 0 100 3",
    preserveAspectRatio: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "var(--color-accent, #FF2DCB)",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35%",
    stopColor: "var(--color-accent, #FF2DCB)",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "65%",
    stopColor: "var(--color-primary, #1FE1FF)",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "var(--color-primary, #1FE1FF)",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 3,
    rx: 1.5,
    fill: "url(#u)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    values: "-20;0",
    dur: "220ms",
    fill: "freeze",
    begin: "0s"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusUnderline6);
export default __webpack_public_path__ + "static/media/focus-underline-6.d19ce4c4a95ab3c9d6ce312dfac42c2c.svg";
export { ForwardRef as ReactComponent };